import React from "react";
import styled from "styled-components";

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  label?: string;
  disabled?: boolean;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  label,
  disabled,
}) => {
  return (
    <Container disabled={disabled} onClick={() => !disabled && onChange(!checked)}>
      {label && <Label>{label}</Label>}
      <SwitchContainer checked={checked} disabled={disabled}>
        <Thumb checked={checked} />
      </SwitchContainer>
    </Container>
  );
};

const Container = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  user-select: none;
`;

const Label = styled.span`
  font-size: 0.95rem;
`;

const SwitchContainer = styled.div<{ checked: boolean; disabled?: boolean }>`
  width: 48px;
  height: 28px;
  border-radius: 16px;
  padding: 3px;
  display: flex;
  align-items: center;
  transition: background-color 0.2s ease;
  background-color: ${({ checked, disabled }) =>
    disabled
      ? "#3e3e3e"
      : checked
      ? "#c8e6c9"
      : "#767577"};
`;

const Thumb = styled.div<{ checked: boolean }>`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: ${({ checked }) =>
    checked ? "rgb(46, 125, 50)" : "#f4f3f4"};
  transform: ${({ checked }) =>
    checked ? "translateX(20px)" : "translateX(0)"};
  transition: transform 0.2s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
`;
